module.exports = __webpack_public_path__ + "img/Type_Ground.651a18fe.png";